import api from '../../api/'
const state = {
    all:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            id: 1,
            libelle: "",
            grilletarifaire_libelle: "",
            tva: "",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        state.all.forEach(element => {       
            console.log('mes elements ',element)    
            row = {
                id: element.id,               
                libelle: element.libelle,   
                grilletarifaire_libelle: element.grilletarifaire_libelle,
                tva: element.tva,
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at
            }
            data.push(row)
        });
        return data;
    }
}
const mutations= {
    setTypeoperations(state, typeoperations) {
        
        state.all = typeoperations
    },
    addTypeoperations(state, typeoperation) {
        state.all.push(typeoperation)
    }
}

const actions={
    get_all_typeoperations_headers({ commit }, serverParams){
        return api.typeoperation_headers.get_all_typeoperations_headers(serverParams).then((response)=>{
            console.log("entete ", response.data.data.data)
            commit('setTypeoperations', response.data.data.data)
            return response.data.data
        })
    },
    post_typeoperations_headers({ commit }, typeoperation){
        return api.typeoperation_headers.post_typeoperations_headers(typeoperation).then((response)=>{
            return response.data
        })
        .catch(error=>{
            console.log("error ",error.response)
            return error.response.data
        })
    },
    put_typeoperations_headers({ commit }, data) {
        return api.typeoperation_headers.put_typeoperations_headers(data.id, data.typeoperation_headers).then((response) => {
            return response.data
        })
        .catch(error => {
            return error.response.data
        })
    },
    show_typeoperations_headers({ commit }, code_operations) {
        return api.typeoperation_headers.show_typeoperations_headers(code_operations).then((response) => {
            return response.data.data;
        })
    }
    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
